export const exterior_view01ImageOptions = {
  angle: 'exterior_view01',
  staticOptions: {
    BowSpirit: 1,
    HullTreatment: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'BowSpirit',
      dependency: 'HullColorways'
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'Sprayhood',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP44/views/exterior_view01.js